
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"65","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1633_43996)","fill":"#9CA3B8"}},[_c('path',{attrs:{"d":"M8.442 8.95a2.32 2.32 0 00-4.27-1.813L.185 16.53a2.32 2.32 0 104.27 1.813L8.442 8.95zM15.49 2.847h-.002a2.831 2.831 0 00-3.712 1.5l-4.988 11.75a2.831 2.831 0 001.5 3.713h.002c1.44.612 3.101-.06 3.712-1.5L16.99 6.56a2.831 2.831 0 00-1.5-3.713zM26.238 4.51a3.242 3.242 0 00-5.969-2.534l-5.63 13.263a3.242 3.242 0 005.97 2.534l5.63-13.263zM45.106 16.525c.067.894.139 1.779.189 2.647-.904.282-1.774.488-2.666.583-1.925.206-3.821.067-5.658-.574-2.802-.98-4.65-2.903-5.59-5.715-.4-1.19-.61-2.41-.593-3.665.036-2.802.944-5.251 3.013-7.2 1.085-1.023 2.388-1.683 3.816-2.09C39.616-.06 41.64-.1 43.67.321a6.05 6.05 0 011.602.554c-.083.885-.189 1.836-.27 2.685-.131-.09-1.339-.944-3.386-1.054-1.49-.08-2.926.124-4.24.872-1.604.916-2.754 2.231-3.249 4.032-.64 2.336-.566 4.624.744 6.74 1.062 1.715 2.63 2.762 4.608 3.126 1.879.346 3.703.071 5.451-.699.036-.016.075-.024.177-.052h-.002zM58.23 10.82h-7.05v8.684h-2.8V.397h10.185v2.427h-7.362v5.538h7.025v2.455l.003.003zM65 .402v19.062l-2.755.029V.401H65z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1633_43996"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h65v20.035H0z"}})])])])
          )
        }
      }
    